import { makeStyles } from "@material-ui/core";

const notificationSettingsStyles = makeStyles((theme) => ({
  root: {
    // paddingLeft: "2%",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    paddingRight: "2.5%",
  },

  grayText: {
    color: theme.palette.text.tertiary,
  },

  tableContainer: {
    width: "100%",
  },
  table: {
    width: "100%",
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  tableBody: {
    display: "block",
    overflowY: "auto",
    [theme.breakpoints.down(823)]: {
      height: `calc(100vh - 305px)`,
    },
  },
  tableRow: {
    borderCollapse: "collapse",
  },
  headTable: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "17.5%",
    background: theme.palette.primary.main,
  },
  headTableTwo: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "50%",
    background: theme.palette.primary.main,
  },

  listText: {
    color: theme.palette.text.primary,
    padding: "1px",
    // borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    borderBottom: `none`,
    width: "17.5%",
  },
  listTextTwo: {
    color: theme.palette.text.primary,
    padding: "1px",
    borderBottom: `none`,
    width: "50%",
    overflow: "hidden",
    borderCollapse: "collapse",
  },

  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  notificationToolbarButtons: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  saveButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.primary,
  },

  tableRow: {
    cursor: "pointer",
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },

  switchAndType: {
    display: "flex",
    alignItems: "start",
    marginTop: "4px",
  },
}));
export default notificationSettingsStyles;
